module.exports = __webpack_public_path__ + "static/banner1-798ed2b0d454ece55da9f1f79da9cc40.png";